import { computed, inject, InjectionToken, type Signal } from '@angular/core';
import { CoreModalService } from './core-modal.service';

// true while a modal is open. The app shows Ionic modals instead of web modals, so it provides its own
export const MODAL_OPEN = new InjectionToken<Signal<boolean>>('MODAL_OPEN', {
  providedIn: 'root',
  factory: () => {
    const coreModalService = inject(CoreModalService);
    return computed(() => coreModalService.modals().length > 0);
  },
});
